// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Raleway:300,700);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `div.error-container {
  width: 100%;
  height: 100vh;
  background: #48a9e6;
  font-family: "Raleway", sans-serif;
  font-weight: 300;
  margin: 0;
  padding: 0;
}

div.error-container #title {
  text-align: center;
  font-size: 40px;
  margin-top: 40px;
  margin-bottom: -40px;
  position: relative;
  color: #fff;
}

div.error-container .circles:after {
  content: "";
  display: inline-block;
  width: 100%;
  height: 100px;
  background: #fff;
  position: absolute;
  top: -50px;
  left: 0;
  transform: skewY(-4deg);
  -webkit-transform: skewY(-4deg);
}

div.error-container .circles {
  background: #fff;
  text-align: center;
  position: relative;
  margin-top: -60px;
}

div.error-container .circles p {
  font-size: 240px;
  color: #fff;
  padding-top: 60px;
  position: relative;
  z-index: 9;
  line-height: 100%;
}

div.error-container .circles p small {
  font-size: 40px;
  line-height: 100%;
  vertical-align: top;
}

div.error-container .circles .circle.small {
  width: 140px;
  height: 140px;
  border-radius: 50%;
  background: #48a9e6;
  position: absolute;
  z-index: 1;
  top: 80px;
  left: 50%;
  animation: 7s smallmove infinite cubic-bezier(1, 0.22, 0.71, 0.98);
  -webkit-animation: 7s smallmove infinite cubic-bezier(1, 0.22, 0.71, 0.98);
  animation-delay: 1.2s;
  -webkit-animation-delay: 1.2s;
}

div.error-container .circles .circle.med {
  width: 200px;
  height: 200px;
  border-radius: 50%;
  background: #48a9e6;
  position: absolute;
  z-index: 1;
  top: 0;
  left: 10%;
  animation: 7s medmove infinite cubic-bezier(0.32, 0.04, 0.15, 0.75);
  -webkit-animation: 7s medmove infinite cubic-bezier(0.32, 0.04, 0.15, 0.75);
  animation-delay: 0.4s;
  -webkit-animation-delay: 0.4s;
}

div.error-container .circles .circle.big {
  width: 400px;
  height: 400px;
  border-radius: 50%;
  background: #48a9e6;
  position: absolute;
  z-index: 1;
  top: 200px;
  right: 0;
  animation: 8s bigmove infinite;
  -webkit-animation: 8s bigmove infinite;
  animation-delay: 3s;
  -webkit-animation-delay: 1s;
}
@keyframes smallmove {
  0% {
    top: 10px;
    left: 45%;
    opacity: 1;
  }
  25% {
    top: 300px;
    left: 40%;
    opacity: 0.7;
  }
  50% {
    top: 240px;
    left: 55%;
    opacity: 0.4;
  }
  75% {
    top: 100px;
    left: 40%;
    opacity: 0.6;
  }
  100% {
    top: 10px;
    left: 45%;
    opacity: 1;
  }
}

@keyframes medmove {
  0% {
    top: 0px;
    left: 20%;
    opacity: 1;
  }
  25% {
    top: 300px;
    left: 80%;
    opacity: 0.7;
  }
  50% {
    top: 240px;
    left: 55%;
    opacity: 0.4;
  }
  75% {
    top: 100px;
    left: 40%;
    opacity: 0.6;
  }
  100% {
    top: 0px;
    left: 20%;
    opacity: 1;
  }
}
@keyframes bigmove {
  0% {
    top: 0px;
    right: 4%;
    opacity: 0.5;
  }
  25% {
    top: 100px;
    right: 40%;
    opacity: 0.4;
  }
  50% {
    top: 240px;
    right: 45%;
    opacity: 0.8;
  }
  75% {
    top: 100px;
    right: 35%;
    opacity: 0.6;
  }
  100% {
    top: 0px;
    right: 4%;
    opacity: 0.5;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/error/error.css"],"names":[],"mappings":"AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,kCAAkC;EAClC,gBAAgB;EAChB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,qBAAqB;EACrB,WAAW;EACX,aAAa;EACb,gBAAgB;EAChB,kBAAkB;EAClB,UAAU;EACV,OAAO;EACP,uBAAuB;EACvB,+BAA+B;AACjC;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,UAAU;EACV,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,SAAS;EACT,kEAAkE;EAClE,0EAA0E;EAC1E,qBAAqB;EACrB,6BAA6B;AAC/B;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,UAAU;EACV,MAAM;EACN,SAAS;EACT,mEAAmE;EACnE,2EAA2E;EAC3E,qBAAqB;EACrB,6BAA6B;AAC/B;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,UAAU;EACV,UAAU;EACV,QAAQ;EACR,8BAA8B;EAC9B,sCAAsC;EACtC,mBAAmB;EACnB,2BAA2B;AAC7B;AA6BA;EACE;IACE,SAAS;IACT,SAAS;IACT,UAAU;EACZ;EACA;IACE,UAAU;IACV,SAAS;IACT,YAAY;EACd;EACA;IACE,UAAU;IACV,SAAS;IACT,YAAY;EACd;EACA;IACE,UAAU;IACV,SAAS;IACT,YAAY;EACd;EACA;IACE,SAAS;IACT,SAAS;IACT,UAAU;EACZ;AACF;;AA8BA;EACE;IACE,QAAQ;IACR,SAAS;IACT,UAAU;EACZ;EACA;IACE,UAAU;IACV,SAAS;IACT,YAAY;EACd;EACA;IACE,UAAU;IACV,SAAS;IACT,YAAY;EACd;EACA;IACE,UAAU;IACV,SAAS;IACT,YAAY;EACd;EACA;IACE,QAAQ;IACR,SAAS;IACT,UAAU;EACZ;AACF;AA6BA;EACE;IACE,QAAQ;IACR,SAAS;IACT,YAAY;EACd;EACA;IACE,UAAU;IACV,UAAU;IACV,YAAY;EACd;EACA;IACE,UAAU;IACV,UAAU;IACV,YAAY;EACd;EACA;IACE,UAAU;IACV,UAAU;IACV,YAAY;EACd;EACA;IACE,QAAQ;IACR,SAAS;IACT,YAAY;EACd;AACF","sourcesContent":["@import url(https://fonts.googleapis.com/css?family=Raleway:300,700);\r\n\r\ndiv.error-container {\r\n  width: 100%;\r\n  height: 100vh;\r\n  background: #48a9e6;\r\n  font-family: \"Raleway\", sans-serif;\r\n  font-weight: 300;\r\n  margin: 0;\r\n  padding: 0;\r\n}\r\n\r\ndiv.error-container #title {\r\n  text-align: center;\r\n  font-size: 40px;\r\n  margin-top: 40px;\r\n  margin-bottom: -40px;\r\n  position: relative;\r\n  color: #fff;\r\n}\r\n\r\ndiv.error-container .circles:after {\r\n  content: \"\";\r\n  display: inline-block;\r\n  width: 100%;\r\n  height: 100px;\r\n  background: #fff;\r\n  position: absolute;\r\n  top: -50px;\r\n  left: 0;\r\n  transform: skewY(-4deg);\r\n  -webkit-transform: skewY(-4deg);\r\n}\r\n\r\ndiv.error-container .circles {\r\n  background: #fff;\r\n  text-align: center;\r\n  position: relative;\r\n  margin-top: -60px;\r\n}\r\n\r\ndiv.error-container .circles p {\r\n  font-size: 240px;\r\n  color: #fff;\r\n  padding-top: 60px;\r\n  position: relative;\r\n  z-index: 9;\r\n  line-height: 100%;\r\n}\r\n\r\ndiv.error-container .circles p small {\r\n  font-size: 40px;\r\n  line-height: 100%;\r\n  vertical-align: top;\r\n}\r\n\r\ndiv.error-container .circles .circle.small {\r\n  width: 140px;\r\n  height: 140px;\r\n  border-radius: 50%;\r\n  background: #48a9e6;\r\n  position: absolute;\r\n  z-index: 1;\r\n  top: 80px;\r\n  left: 50%;\r\n  animation: 7s smallmove infinite cubic-bezier(1, 0.22, 0.71, 0.98);\r\n  -webkit-animation: 7s smallmove infinite cubic-bezier(1, 0.22, 0.71, 0.98);\r\n  animation-delay: 1.2s;\r\n  -webkit-animation-delay: 1.2s;\r\n}\r\n\r\ndiv.error-container .circles .circle.med {\r\n  width: 200px;\r\n  height: 200px;\r\n  border-radius: 50%;\r\n  background: #48a9e6;\r\n  position: absolute;\r\n  z-index: 1;\r\n  top: 0;\r\n  left: 10%;\r\n  animation: 7s medmove infinite cubic-bezier(0.32, 0.04, 0.15, 0.75);\r\n  -webkit-animation: 7s medmove infinite cubic-bezier(0.32, 0.04, 0.15, 0.75);\r\n  animation-delay: 0.4s;\r\n  -webkit-animation-delay: 0.4s;\r\n}\r\n\r\ndiv.error-container .circles .circle.big {\r\n  width: 400px;\r\n  height: 400px;\r\n  border-radius: 50%;\r\n  background: #48a9e6;\r\n  position: absolute;\r\n  z-index: 1;\r\n  top: 200px;\r\n  right: 0;\r\n  animation: 8s bigmove infinite;\r\n  -webkit-animation: 8s bigmove infinite;\r\n  animation-delay: 3s;\r\n  -webkit-animation-delay: 1s;\r\n}\r\n\r\n@-webkit-keyframes smallmove {\r\n  0% {\r\n    top: 10px;\r\n    left: 45%;\r\n    opacity: 1;\r\n  }\r\n  25% {\r\n    top: 300px;\r\n    left: 40%;\r\n    opacity: 0.7;\r\n  }\r\n  50% {\r\n    top: 240px;\r\n    left: 55%;\r\n    opacity: 0.4;\r\n  }\r\n  75% {\r\n    top: 100px;\r\n    left: 40%;\r\n    opacity: 0.6;\r\n  }\r\n  100% {\r\n    top: 10px;\r\n    left: 45%;\r\n    opacity: 1;\r\n  }\r\n}\r\n@keyframes smallmove {\r\n  0% {\r\n    top: 10px;\r\n    left: 45%;\r\n    opacity: 1;\r\n  }\r\n  25% {\r\n    top: 300px;\r\n    left: 40%;\r\n    opacity: 0.7;\r\n  }\r\n  50% {\r\n    top: 240px;\r\n    left: 55%;\r\n    opacity: 0.4;\r\n  }\r\n  75% {\r\n    top: 100px;\r\n    left: 40%;\r\n    opacity: 0.6;\r\n  }\r\n  100% {\r\n    top: 10px;\r\n    left: 45%;\r\n    opacity: 1;\r\n  }\r\n}\r\n\r\n@-webkit-keyframes medmove {\r\n  0% {\r\n    top: 0px;\r\n    left: 20%;\r\n    opacity: 1;\r\n  }\r\n  25% {\r\n    top: 300px;\r\n    left: 80%;\r\n    opacity: 0.7;\r\n  }\r\n  50% {\r\n    top: 240px;\r\n    left: 55%;\r\n    opacity: 0.4;\r\n  }\r\n  75% {\r\n    top: 100px;\r\n    left: 40%;\r\n    opacity: 0.6;\r\n  }\r\n  100% {\r\n    top: 0px;\r\n    left: 20%;\r\n    opacity: 1;\r\n  }\r\n}\r\n\r\n@keyframes medmove {\r\n  0% {\r\n    top: 0px;\r\n    left: 20%;\r\n    opacity: 1;\r\n  }\r\n  25% {\r\n    top: 300px;\r\n    left: 80%;\r\n    opacity: 0.7;\r\n  }\r\n  50% {\r\n    top: 240px;\r\n    left: 55%;\r\n    opacity: 0.4;\r\n  }\r\n  75% {\r\n    top: 100px;\r\n    left: 40%;\r\n    opacity: 0.6;\r\n  }\r\n  100% {\r\n    top: 0px;\r\n    left: 20%;\r\n    opacity: 1;\r\n  }\r\n}\r\n\r\n@-webkit-keyframes bigmove {\r\n  0% {\r\n    top: 0px;\r\n    right: 4%;\r\n    opacity: 0.5;\r\n  }\r\n  25% {\r\n    top: 100px;\r\n    right: 40%;\r\n    opacity: 0.4;\r\n  }\r\n  50% {\r\n    top: 240px;\r\n    right: 45%;\r\n    opacity: 0.8;\r\n  }\r\n  75% {\r\n    top: 100px;\r\n    right: 35%;\r\n    opacity: 0.6;\r\n  }\r\n  100% {\r\n    top: 0px;\r\n    right: 4%;\r\n    opacity: 0.5;\r\n  }\r\n}\r\n@keyframes bigmove {\r\n  0% {\r\n    top: 0px;\r\n    right: 4%;\r\n    opacity: 0.5;\r\n  }\r\n  25% {\r\n    top: 100px;\r\n    right: 40%;\r\n    opacity: 0.4;\r\n  }\r\n  50% {\r\n    top: 240px;\r\n    right: 45%;\r\n    opacity: 0.8;\r\n  }\r\n  75% {\r\n    top: 100px;\r\n    right: 35%;\r\n    opacity: 0.6;\r\n  }\r\n  100% {\r\n    top: 0px;\r\n    right: 4%;\r\n    opacity: 0.5;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
